import React from 'react'
import './styles.css'

const Title = () => {
    return (
        <h2>Calculator / Rate Converter</h2>
    )
}

export default Title